import { init as initTraceway } from '@tracewayapp/frontend';
import hljs from 'highlight.js/lib/core';
import bash from 'highlight.js/lib/languages/bash';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import php from 'highlight.js/lib/languages/php';
import python from 'highlight.js/lib/languages/python';
import Tooltip from "@ryangjchandler/alpine-tooltip";
import collapse from '@alpinejs/collapse'

/*
 * highlight.js is imported from lib/core with five languages registered by
 * hand, not as the default build. The default registers every language it
 * ships -- around 190 -- and was the bulk of a 1207 KiB bundle that every
 * public page loaded, including articles with no code on them at all.
 *
 * Five is not a guess. Four are named explicitly in markup
 * (language-php/javascript/python/bash) and the rest of the highlighted
 * blocks carry no class at all, so they go through auto-detection: those are
 * `composer require`, a PHP snippet and an npm package name on the
 * integration pages. json is registered for the same auto-detected set.
 * Anything outside these five now renders as plain text rather than
 * mis-highlighted, which is the better failure.
 *
 * The <pre> blocks on /mcp are untouched either way -- they have no <code>
 * child, so the selector below never sees them, and their hand-written
 * colour spans survive.
 *
 * `./bootstrap` used to be imported here and brought lodash and axios into
 * window. Neither is referenced anywhere in the project; they were the
 * Laravel skeleton's defaults, shipped to every visitor for years.
 */
/*
 * Traceway browser SDK (project "WaAPI Web"): uncaught errors, web vitals and
 * error-triggered session replay. Vite inlines the connection string at build
 * time; without it the SDK stays off, which is the local default.
 */
if (import.meta.env.VITE_TRACEWAY_WEB_CONNECTION_STRING) {
    initTraceway(import.meta.env.VITE_TRACEWAY_WEB_CONNECTION_STRING);
}

hljs.registerLanguage('bash', bash);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('json', json);
hljs.registerLanguage('php', php);
hljs.registerLanguage('python', python);

Alpine.plugin(Tooltip);
Alpine.plugin(collapse);

window.Alpine = Alpine;

document.addEventListener('DOMContentLoaded', (event) => {
    document.querySelectorAll('pre code').forEach((el) => {
        hljs.highlightElement(el);
    });
});
